import { ModelBase } from 'store/model-base';
import { PromotionType } from 'core/constants';

export class TradeInOfferPromo extends ModelBase {
    public static storeName: string = 'tradeInOfferPromo';

    public accountGuid: string;
    public lineId: string;
    public offerAmount: string;
    public eligiblePromotions: TradeEligiblePromotion[];
    public isTradeInPlusUpPromoEligible: boolean;
    public plusUpOfferAmount: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        const tradeInPlusUp: TradeEligiblePromotion[] = data.eligiblePromotions?.filter((promo: TradeEligiblePromotion) => promo.id === PromotionType.TRADEIN_PROMO_PLUSUP);
        data.plusUpOfferAmount = tradeInPlusUp?.length > 0 ? tradeInPlusUp[0].amount : undefined;
        data.isTradeInPlusUpPromoEligible = data.eligiblePromotions?.some((promo: TradeEligiblePromotion) => promo.id === PromotionType.TRADEIN_PROMO_PLUSUP);
        
        return super.create<T>(data);
    }
}
